import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage
    id="not-found.text"
    defaultMessage="The page you are looking for cannot be found. It may have been moved or deleted."
  />
);
